// Festivos oficiales para Glattpark (8152, Opfikon, Cantón Zúrich)
// Formato ISO YYYY-MM-DD. Añadir/editar aquí según calendario laboral del equipo.
export const GLATTPARK_HOLIDAYS: string[] = [
  // 2026
  '2026-01-01', // Neujahr
  '2026-01-02', // Berchtoldstag
  '2026-04-03', // Karfreitag
  '2026-04-06', // Ostermontag
  '2026-05-01', // Tag der Arbeit
  '2026-05-14', // Auffahrt
  '2026-05-25', // Pfingstmontag
  '2026-08-01', // Bundesfeier
  '2026-09-14', // Knabenschiessen (Montag, ZH)
  '2026-12-25', // Weihnachten
  '2026-12-26', // Stephanstag
  // 2027
  '2027-01-01',
  '2027-03-26',
  '2027-03-29',
  '2027-05-01',
  '2027-05-06',
  '2027-05-17',
  '2027-08-01',
  '2027-12-25',
  '2027-12-26',
];

export const isGlattparkHoliday = (date: Date): boolean => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return GLATTPARK_HOLIDAYS.includes(`${y}-${m}-${d}`);
};
